import React from 'react';
import PropTypes from 'prop-types';
import tc from 'tinycolor2';
import { css, cx } from '@bd/bdui-styles/emotion';
import AccordionToggle from '../../components/AccordionToggle';
import { colors } from '../../styles';

const styles = css`
  color: #FFFFFF;
  .SectionAbout_descriptionSection{
    @media(min-width: 768px){
      padding-top: 100px;
    }
  }
  .SectionAbout_descriptionHead{
    text-align: center;
  }
  .SectionAbout_descriptionHead {
    display: none;
    @media (min-width: 768px) {
      display: block;
      margin-bottom: 0.4em;
    }
  }
  .SectionAbout_descWrapper {
    @media (min-width: 992px) {
      &::after {
        content: '';
        display: table;
        clear: both;
      }
    }
  }
  .SectionAbout_description {
    font-size: 15px;
    font-weight: 300;
    letter-spacing: 0.022353em;
    line-height: 1.941176;
    margin: 0;
    text-align: center;
    @media (min-width: 768px) {
      font-size: 16px;
    }
    @media (min-width: 992px) {
      font-size: 17px;
    }
  }
  .SectionAbout_logo {
    display: block;
    max-width: 100%;
    margin-bottom: 14px;
    @media (min-width: 768px) {
      float: right;
      width: 310px;
      margin-left: 48px;
      margin-bottom: 0;
    }
    @media (min-width: 992px) {
      width: 357px;
      margin-left: 64px;
    }
  }
  .ContentSection_table{
    margin: auto;
    width: 100%;
    @media(min-width: 992px){
      width: 900px;
    }
  }
  .thead-dark{
    tr{
      th{
        text-align: center;
        font-weight: bold;
        font-size: 20px;
        padding: 15px;
        background-color: ${tc(colors.color4).lighten(17).toString()};
      }
    }
  }
  table{
    thead{
      th{
        border: none;
      }
    }
    td{
      border: none;
      padding: 15px;
    }
    tbody{
      tr{
        background-color: ${colors.color3};
        color: black;
        &:nth-child(even){
          background-color: ${colors.color3Darker};
        }
        td{
          padding-left: 60px;
          padding-right: 23px;
          position: relative;
          &:before{
            content: '';
            height: 8px;
            width: 8px;
            background-color: ${colors.color6};
            position: absolute;
            left: 30px;
            top: 23px;
          }
        }
      }
    }
  }
`;


function SectionFeatures({ className, community }) {
  return (
    <div className={cx(styles, className)}>
      <AccordionToggle
        openOnId="features"
        button="Neighborhood Features"
        id="features"
      >
        <div className="SectionAbout_descriptionSection">
          <h2 className="CommunityDetail_sectionHead SectionAbout_descriptionHead GoldText">Neighborhood Features</h2>
          <div className="SectionAbout_descWrapper">
            {
              community.features &&
              community.features[0].bullet_points &&
              community.features[0].bullet_points.length > 0 &&
              <table className="ContentSection_table table">
                <thead className="thead-dark">
                  <tr>
                    <th>{community.features[0].title}</th>
                  </tr>
                </thead>
                <tbody>
                  {community.features[0].bullet_points.map(item => (
                    <tr key={item} className="ContentSection_tableBullet">
                      <td>{item}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            }
          </div>
        </div>
      </AccordionToggle>
    </div>
  );
}

SectionFeatures.propTypes = {
  className: PropTypes.string,
  community: PropTypes.object.isRequired,
};

SectionFeatures.defaultProps = {
  className: undefined,
};

export default SectionFeatures;



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/SectionFeatures.js